import { useCallback, useContext, useMemo } from 'react';
import { app } from 'router/routes';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as AddIcon } from 'assets/icons/Add.svg';
import { SvgIcon } from '@mui/material';
import { AffiliationsContext } from '../AffiliationsContext';
import { affiliationsHooks } from '..';

const useHeaderBtns = () => {
    const navigate = useNavigate()
    const { affiliationGroups, groupTab } = useContext(AffiliationsContext)
    const affiliationGroup = affiliationGroups?.[groupTab]

    const groupTabByName = affiliationsHooks.useAffiliationGroupItems()

    // נקבל את האובייקט של הקבוצה הנכחית
    // דרכו נקבל את האובייקט של הטאב
    const groupTabItem = groupTabByName?.[affiliationGroup?.name]

    const goAddAffiliation = useCallback(() => {
        if (affiliationGroup?.id)
            navigate(`${app.affiliations}/${affiliationGroup.id}/new`)
    }, [affiliationGroup])

    const headerBtns = useMemo(() => [
        {
            id: 1,
            icon: <SvgIcon component={AddIcon} inheritViewBox />,
            label: groupTabItem?.createButtonLabel,
            action: goAddAffiliation,
            height: "35px"
        }
    ], [affiliationGroups, groupTabItem])

    return headerBtns
}

export default useHeaderBtns